module.exports = __webpack_public_path__ + "img/1be28c613524d23762af1632f21872d5.svg";